package com.milta.core.localization.translations.de

import com.milta.core.localization.OcrScanStrings

internal val OcrScan = OcrScanStrings(
    scanTitle = "Dokument scannen",
    reviewTitle = "Daten überprüfen",
    fileSentSuffix = "gerade gesendet",
    analysingTitle = "Dokument wird gelesen…",
    analysingSubtitle = "Wir erkennen die Zustellungen auf dem Foto. Das dauert nur wenige Sekunden.",
    deliveriesDetectedSuffix = "Zustellungen erkannt",
    toCompleteSuffix = "zu vervollständigen",
    reviewHint = "Vervollständigen Sie die markierten Zustellungen, bevor Sie sie zur Tour hinzufügen",
    addressMissingWarning = "Adresse fehlt",
    nameMissingWarning = "Name fehlt",
    recipientMissingPlaceholder = "Empfänger nicht erkannt",
    phoneNotDetectedNote = "Telefonnummer nicht erkannt — blockiert das Hinzufügen nicht",
    deadlineLabelPrefix = "Frist",
    completeLinkLabel = "Vervollständigen",
    addToRouteButtonPrefix = "Zur Tour hinzufügen",
    correctionRecipientLabel = "Empfänger",
    correctionAddressLabel = "Adresse",
    correctionPhoneLabel = "Telefon",
    correctionDeadlineLabel = "Frist",
    attemptLabel = "Versuch",
    unreadableTitle = "Foto nicht lesbar.",
    unreadableMessage = "Wir haben auf diesem Bild keine Zustellung erkannt — machen Sie ein gut ausgerichtetes, gut beleuchtetes Foto.",
    retakePhotoButton = "Foto erneut aufnehmen",
    manualEntryButton = "Manuell eingeben",
    maxAttemptsTitle = "Nach 2 Versuchen weiterhin nicht lesbar.",
    maxAttemptsMessage = "Vervollständigen Sie diese Zustellung manuell, oder starten Sie den Scan mit einem neuen Dokument neu.",
    retakeUnavailableLabel = "Foto erneut aufnehmen — nicht verfügbar",
    rateLimitTitle = "Zu viele Scans in letzter Zeit durchgeführt.",
    rateLimitMessage = "Versuchen Sie es etwas später erneut, oder vervollständigen Sie diese Zustellung in der Zwischenzeit manuell.",
    rateLimitRetakeUnavailableLabel = "Foto erneut aufnehmen — derzeit nicht verfügbar",
)
